import React, {useEffect, useState} from 'react';
import {
  FaArrowLeft,
  FaTrophy,
  FaBullseye,
  FaStar,
  FaSyncAlt,
  FaExchangeAlt,
  FaChevronRight,
  FaInfoCircle,
} from 'react-icons/fa';
import {useNavigate, useLocation} from 'react-router-dom';
import Get from './components/Get'; // ✅ make sure path is correct

const PostFree = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const gameData = location.state?.data || {name: {name: 'Game'}};

  const [bhav, setBhav] = useState(null);

  const fetchSetting = async () => {
    try {
      const res = await Get.Setting();
      setBhav(res?.data?.bhav || null);
    } catch (err) {
      console.error('Error fetching bhav:', err);
    }
  };

  useEffect(() => {
    fetchSetting(); // run on mount
  }, [location.pathname]); // re-fetch when navigating to this page

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.headerContainer}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>
          <FaArrowLeft color="#fff" />
        </button>
        <h2 style={styles.headerTitle}>{gameData?.name?.name || 'Game'}</h2>
        <div style={styles.headerPlaceholder} />
      </div>

      <div style={styles.scrollContainer}>
        {/* Game Rates Section */}
        <div style={styles.ratesSection}>
          <div style={styles.ratesTitleContainer}>
            <FaTrophy color="#F3DE11" />
            <h3 style={styles.ratesTitle}>Game Rates</h3>
            <FaTrophy color="#F3DE11" />
          </div>

          <div style={styles.ratesContainer}>
            <div style={{...styles.rateCard, backgroundColor: '#21CB84'}}>
              <div style={styles.rateIconContainer}>
                <FaBullseye color="#fff" size={20} />
              </div>
              <p style={styles.rateLabel}>Jodi</p>
              {bhav ? (
                <p style={styles.rateValue}>₹10 = ₹{bhav.min_amount * 10}</p>
              ) : (
                <p style={styles.rateValue}>Loading...</p>
              )}
            </div>

            <div style={{...styles.rateCard, backgroundColor: '#10C2AA'}}>
              <div style={styles.rateIconContainer}>
                <FaStar color="#fff" size={20} />
              </div>
              <p style={styles.rateLabel}>Haraf</p>
              {bhav ? (
                <p style={styles.rateValue}>₹10 = ₹{bhav.text * 10}</p>
              ) : (
                <p style={styles.rateValue}>Loading...</p>
              )}
            </div>
          </div>
        </div>

        {/* Game Options Section */}
        <div style={styles.gameOptionsSection}>
          <h3 style={styles.sectionTitle}>Choose Your Game</h3>
          <div style={styles.gameOptionsContainer}>
            <button
              style={{...styles.gameButton, backgroundColor: '#1057D7'}}
              onClick={() => navigate('/double', {state: {data: gameData}})}>
              <div style={styles.gameButtonContent}>
                <div style={styles.gameIconContainer}>
                  <FaSyncAlt color="#fff" />
                </div>
                <div style={styles.gameTextContainer}>
                  <p style={styles.gameButtonTitle}>Jodi</p>
                  <p style={styles.gameButtonSubtitle}>Double Numbers</p>
                </div>
                <FaChevronRight color="#fff" />
              </div>
            </button>

            <button
              style={{...styles.gameButton, backgroundColor: '#EDA01E'}}
              onClick={() => navigate('/crossing', {state: {data: gameData}})}>
              <div style={styles.gameButtonContent}>
                <div style={styles.gameIconContainer}>
                  <FaExchangeAlt color="#fff" />
                </div>
                <div style={styles.gameTextContainer}>
                  <p style={styles.gameButtonTitle}>Crossing</p>
                  <p style={styles.gameButtonSubtitle}>Cross Pattern</p>
                </div>
                <FaChevronRight color="#fff" />
              </div>
            </button>

            <button
              style={{...styles.gameButton, backgroundColor: '#09B7AE'}}
              onClick={() => navigate('/harup', {state: {data: gameData}})}>
              <div style={styles.gameButtonContent}>
                <div style={styles.gameIconContainer}>
                  <FaStar color="#fff" />
                </div>
                <div style={styles.gameTextContainer}>
                  <p style={styles.gameButtonTitle}>Harup</p>
                  <p style={styles.gameButtonSubtitle}>Single Digit</p>
                </div>
                <FaChevronRight color="#fff" />
              </div>
            </button>
          </div>
        </div>

        {/* Info Banner */}
        <div style={styles.infoBanner}>
          <div style={styles.infoIconContainer}>
            <FaInfoCircle color="#00318bff" />
          </div>
          <div style={styles.infoTextContainer}>
            <h4 style={styles.infoTitle}>Quick Tip</h4>
            <p style={styles.infoText}>
              Select any game type above to start playing and win exciting
              prizes!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostFree;

const styles = {
  container: {
    flex: 1,
    backgroundColor: '#F8FAFB',
    minHeight: '100vh',
    margin: 0,
  },
  headerContainer: {
    backgroundColor: '#1057D7',
    padding: '15px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    cursor: 'pointer',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#FFFFFF',
    flex: 1,
    textAlign: 'center',
  },
  headerPlaceholder: {width: 40},
  scrollContainer: {padding: 14},
  ratesSection: {marginTop: 20},
  ratesTitleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    marginBottom: 20,
  },
  ratesTitle: {fontSize: 22, fontWeight: '700', color: '#1F2937'},
  ratesContainer: {display: 'flex', justifyContent: 'space-between'},
  rateCard: {
    borderRadius: 20,
    padding: 20,
    color: '#fff',
    textAlign: 'center',
    width: '34%',
  },
  rateIconContainer: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
  },
  rateLabel: {fontSize: 16, fontWeight: '600', color: '#fff', marginBottom: 8},
  rateValue: {fontSize: 18, fontWeight: '700', color: '#fff'},
  gameOptionsSection: {marginTop: 30},
  sectionTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1F2937',
    textAlign: 'center',
    marginBottom: 20,
  },
  gameOptionsContainer: {display: 'flex', flexDirection: 'column', gap: 16},
  gameButton: {
    borderRadius: 16,
    padding: 12,
    border: 'none',
    cursor: 'pointer',
    display: 'block',
    width: '100%',
    color: '#fff',
  },
  gameButtonContent: {display: 'flex', alignItems: 'center'},
  gameIconContainer: {
    width: 36,
    height: 36,
    borderRadius: 28,
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
  },
  gameTextContainer: {flex: 1},
  gameButtonTitle: {fontSize: 16, fontWeight: '700', marginBottom: 4},
  gameButtonSubtitle: {fontSize: 14, opacity: 0.8},
  infoBanner: {
    marginTop: 30,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 12,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderLeft: '4px solid #1057D7',
  },
  infoIconContainer: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F0F9FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
  },
  infoTextContainer: {flex: 1},
  infoTitle: {fontSize: 16, fontWeight: '600', marginBottom: 4},
  infoText: {fontSize: 14, color: '#6B7280'},
};
